import React from 'react';
import { useSelector } from 'react-redux';
import { Field } from '../../types';
import { getQuote } from './QuoteSlice';

export interface FormHeadingProps {
    field: Field;
}
function FromHeading(props: FormHeadingProps) {
  const { field } = props;
  const quoteData = useSelector(getQuote);
  const title = field.text.replace('{quote_forename}', quoteData.data.quote_forename ?? '');
  return (
    <div className="my-4 form-heading">
      <h3 className="mb-4 form-heading__text">{title}</h3>
      <div className="divider" />
    </div>
  );
}

export default FromHeading;
